import React, { useEffect, useState, useContext  } from 'react'
import { getUser, formatCurrency } from '../../../../../utils/Common';
import Spinner from '../../../../../components/Spinner';
import Skeleton from '../../../../../components/ui/Skeleton';
import { useRemmitances } from '../../../../../hooks/useRemmitances';

const SummaryRemmitancesStats = () => {
    const { getRemittancesInsights  } = useRemmitances();
    const [stats, setStats] = useState(null);
    const user = getUser();

    const handleGetStatsUser = async () => {
        const abortController = new AbortController();
        const response = await getRemittancesInsights(abortController.signal);
        setStats(response?.payload);
    };

    useEffect(() => { 
        handleGetStatsUser();
    }, []);

  return (
        !stats ? (
        <div className="row mx-2 mt-3">
          <div className="col-12 col-md-4 p-2">
              <Skeleton variant="rectangular" width="100%" height="100px" />
          </div>
          <div className="col-12 col-md-4 p-2">
              <Skeleton variant="rectangular" width="100%" height="100px" />
          </div>
          {user.roleId >= 3 && (
           <div className="col-12 col-md-4 p-2">
               <Skeleton variant="rectangular" width="100%" height="100px" />
            </div>
            )}
          <div className="col-12 col-md-4 p-2">
              <Skeleton variant="rectangular" width="100%" height="100px" />
          </div>
        </div>
        ) : (
              <div className="row mx-2">
                  <div className="col-12 col-md-4 p-2">
                    <div className="dashboardCard py-6">
                      <div className="titles-dashb">GIROS PAGADOS EN EL MES</div>
                      <div className="text-bold subtitles-dashb">
                        ({stats?.RemesasEntregadasMes}) <span className="subtitles-amount-dashb">{formatCurrency(stats?.MontoRemesasEntregadasMes)}</span>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-4 p-2">
                    <div className="dashboardCard py-6">
                      <div className="titles-dashb">GIROS VENDIDOS</div>
                      <div className="text-bold subtitles-dashb">
                        ({stats?.RemesasEnProceso}) <span className="subtitles-amount-dashb">{formatCurrency(stats?.MontoRemesasEnProceso)}</span>
                      </div>
                    </div>
                  </div>
                  {user.roleId >= 3 && (
                    <div className="col-12 col-md-4 p-2">
                      <div className="dashboardCard py-6">
                        <div className="titles-dashb">GIROS PENDIENTES DE PAGO</div>
                        <div className="text-bold subtitles-dashb">
                          ({stats?.RemesasEnProcesoEntrega}) <span className="subtitles-amount-dashb">{formatCurrency(stats?.MontoRemesasEnProcesoEntrega)}</span>
                        </div>
                      </div>
                    </div>
                  )}
                  <div className= {`col-12 col-md-${user.roleId >=3 ? '12':'4'}  p-2`}>
                    <div className="dashboardCard py-6">
                      <div className="titles-dashb">GIROS PAGADOS X AÑO</div>
                      <div className="text-bold subtitles-dashb">
                        ({stats?.RemesasEntregadasAño}) <span className="subtitles-amount-dashb">{formatCurrency(stats?.MontoRemesasEntregadasAño)}</span>
                      </div>
                    </div>
                  </div>
                </div>
        )
  )
}

export default SummaryRemmitancesStats